import React from 'react';

interface ErrorPlaceholderProps {
    message?: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    onMouseEnter?: (event: React.MouseEvent<HTMLDivElement>) => void;
    onMouseLeave?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

function ErrorPlaceholder({ message, onClick, onMouseEnter, onMouseLeave }: ErrorPlaceholderProps) {
    return (
        <div className="qr-alt" style={{ width: "100%", maxWidth: "300px", height: "100%" }} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "100%",
                    borderRadius: "8px",
                    backgroundColor: "#f2f4a9ff",
                    opacity: 0.9,
                    cursor: "not-allowed",
                }}
            >
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    color: "#842029",
                }}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="#842029" strokeWidth="2" />
                        <path d="M12 7v5M12 16h.01" stroke="#842029" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <div style={{ fontSize: "14px", marginTop: "8px", fontWeight: "500", lineHeight: "1.4", padding: "0 10px" }}>
                        {message || "Error rendering Data"}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ErrorPlaceholder;

